<template>
  <el-card
    header="Information"
    shadow="never"
  >
    <el-col :span="12">
      <p>
        <b>Consignment</b><br>
        {{ consignment.con_full }}
      </p>

      <p>
        <b>Carrier</b><br>
        <router-link
          :to="{ name:'manage-carriers-carrier', params: { carrierId: consignment.carrier.id } }"
        >
          {{ $_.get(consignment, 'carrier.name', '-') || '-' }}
        </router-link>
      </p>
      <p>
        <b>Service</b><br>
        {{ $_.get(consignment, 'service.name', '-') }} [{{ $_.get(consignment, 'service.chainit', '-') }}]
      </p>

      <p>
        <b>Despatch Date</b><br>
        {{ $moment($_.get(consignment, 'con_despatch_date', '-')).format('DD/MM/YYYY') }}
      </p>

      <p>
        <b>Created At</b><br>
        {{ $moment($_.get(consignment, 'created_at', '-')).format('DD/MM/YYYY hh:mm a') }}
      </p>

      <p>
        <b>Manifested At</b><br>
        {{ consignment.con_manifest_date ? $moment(consignment.con_manifest_date).format('DD/MM/YYYY hh:mm a') : '-' }}
      </p>

      <p>
        <b>Estimate Date</b><br>
        {{ consignment.con_estimate_date ? $moment(consignment.con_estimate_date).format('DD/MM/YYYY') : '-' }}
      </p>
    </el-col>
    <el-col :span="12">
      <p>
        <b>Special Instructions</b><br>
        {{ $_.get(consignment, 'con_special_instructions', '-') || '-' }}
      </p>

      <p>
        <b>Pickup</b><br>
        <router-link
          v-if="consignment.pickup"
          :to="{ name:'customerservice-pickups-pickup', params: { pickupId: consignment.pickup.id } }"
        >
          {{ consignment.pickup ? $_.get(consignment.pickup, 'booking_reference', '-') : '-' }}
        </router-link>
        <span v-else>
          -
        </span>
      </p>

      <p>
        <b>Cost Center</b><br>
        {{ $_.get(consignment, 'con_costcent', '-') || '-' }}
      </p>

      <p>
        <b>Est. Cost</b><br>
        ${{ $_.get(consignment, 'con_est_price', '-') || '-' }}
      </p>

      <p>
        <b>Created By</b><br>
        {{ getExtData('created_by_email') ? getExtData('created_by_email') : '-' }}
      </p>

      <p>
        <b>Reference</b><br>
        {{ $_.get(consignment, 'con_ref', '-') || '-' }}
      </p>

      <p>
        <b>Internal Reference</b><br>
        {{ $_.get(consignment, 'con_internal_ref', '-') || '-' }}
      </p>
    </el-col>
  </el-card>
</template>
<script>
export default {
  props: {
    consignment: {
      type: Object,
      required: true
    }
  },
  methods: {
    getExtData (key) {
      if (this.consignment.con_ext_data && this.consignment.con_ext_data.length) {
        let data = JSON.parse(this.consignment.con_ext_data)
        return data[key]
      }

      return '-'
    }
  }
}
</script>
